import { useContext } from "react";
import { AppContext } from "../App";
import AlertPopup from "./ui/AlertPopup";
import WarningIcon from "../icons/WarningIcon";

export default function FiscalPrinterPopup() {
	const {
		apiSettings,
		config,
		setSettingsPage,
		setSettingsVisible,
		setHideFiscalPrinterWarning,
	} = useContext(AppContext);
	const fiscalPrinterEnabled = apiSettings?.mandant?.fiscal_printers == 1;
	const virtualPrinterEnabled = apiSettings?.mandant?.fiskaly == 1;
	const showWarning =
		(fiscalPrinterEnabled || virtualPrinterEnabled) &&
		!(fiscalPrinterEnabled && config?.fiscal_printer_id) &&
		!(virtualPrinterEnabled && config?.virtual_printer_id) &&
		!(
			fiscalPrinterEnabled &&
			virtualPrinterEnabled &&
			(config?.fiscal_printer_id || config?.virtual_printer_id)
		);

	let title = "Stampante";
	let message = "Seleziona una stampante per continuare.";
	let settingsPage = "main";

	if (fiscalPrinterEnabled && virtualPrinterEnabled) {
		title = "Stampante fiscale o virtuale";
		message = "Seleziona una stampante fiscale o virtuale per continuare.";
		settingsPage = config?.fiscal_printer_id ? "fiscal_printer" : "virtual_printer";
	} else if (fiscalPrinterEnabled) {
		title = "Stampante fiscale";
		message = "Seleziona una stampante fiscale per continuare.";
		settingsPage = "fiscal_printer";
	} else if (virtualPrinterEnabled) {
		title = "Stampante virtuale";
		message = "Seleziona una stampante virtuale per continuare.";
		settingsPage = "virtual_printer";
	}

	if (!showWarning) return null;

	return (
		<AlertPopup className="alert-compact">
			<div className="alert-compact-head">
				<WarningIcon className="alert-badge-icon" aria-hidden="true" />
				<strong className="alert-popup-title">{title} non selezionata</strong>
			</div>
			<p className="alert-compact-message">{message}</p>
			<div className="alert-compact-actions">
				<button
					className="button"
					onClick={() => {
						setSettingsPage(settingsPage);
						setSettingsVisible(true);
					}}
				>
					Seleziona
				</button>
				<button className="alert-text-link" onClick={() => setHideFiscalPrinterWarning(true)}>
					Non mostrare più
				</button>
			</div>
		</AlertPopup>
	);
}
